module.exports = __webpack_public_path__ + "static/media/feedback-good.3f494f5d.png";